import styled from 'styled-components';

export const IntegrationDescriptionModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .tooltip-container {
    margin-left: 5px;
  }

  .alert {
    margin-bottom: 0;
  }
`;
